import { useCharitableGivingContext } from '../context/useCharitableGivingContext';
import { Step } from '../CharitableGiving.meta';

interface Params {
  currentStep: Step;
}

export const useNavigation = ({ currentStep }: Params) => {
  const { steps } = useCharitableGivingContext();

  const stepIndex = steps.findIndex(step => step === currentStep);

  if (stepIndex === -1) {
    throw new Error(`Step ${currentStep} not found in workflow steps`);
  }

  const previousStep = stepIndex === 0 ? null : steps[stepIndex - 1];
  const nextStep = stepIndex === steps.length - 1 ? null : steps[stepIndex + 1];
  const progress = ((stepIndex + 1) / steps.length) * 100;
  const isFirstStep = stepIndex === 0;

  return {
    previousStep,
    nextStep,
    progress,
    isFirstStep,
    stepIndex,
  };
};
